export class User {
    id: number;
    username:string;
    password:string;
    name: string;
    group_id: number;
    email: string;
    token: string;
}
